// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/stake/v1/stake.proto (package penumbra.core.component.stake.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { ConsensusKey, GovernanceKey, IdentityKey } from "../../../keys/v1/keys_pb.js";
import { Amount } from "../../../num/v1/num_pb.js";
import { Epoch } from "../../sct/v1/sct_pb.js";
import { BalanceCommitment } from "../../../asset/v1/asset_pb.js";

/**
 * A Penumbra ZK undelegate claim proof.
 *
 * @generated from message penumbra.core.component.stake.v1.ZKUndelegateClaimProof
 */
export const ZKUndelegateClaimProof = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ZKUndelegateClaimProof",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Describes a validator's configuration data.
 *
 * @generated from message penumbra.core.component.stake.v1.Validator
 */
export const Validator = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.Validator",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "consensus_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "website", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "funding_streams", kind: "message", T: FundingStream, repeated: true },
    { no: 7, name: "sequence_number", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "governance_key", kind: "message", T: GovernanceKey },
  ],
);

/**
 * For storing the list of keys of known validators.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorList
 */
export const ValidatorList = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorList",
  () => [
    { no: 1, name: "validator_keys", kind: "message", T: IdentityKey, repeated: true },
  ],
);

/**
 * A portion of a validator's commission.
 *
 * @generated from message penumbra.core.component.stake.v1.FundingStream
 */
export const FundingStream = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.FundingStream",
  () => [
    { no: 1, name: "to_address", kind: "message", T: FundingStream_ToAddress, oneof: "recipient" },
    { no: 2, name: "to_community_pool", kind: "message", T: FundingStream_ToCommunityPool, oneof: "recipient" },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.FundingStream.ToAddress
 */
export const FundingStream_ToAddress = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.FundingStream.ToAddress",
  () => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rate_bps", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "FundingStream_ToAddress"},
);

/**
 * @generated from message penumbra.core.component.stake.v1.FundingStream.ToCommunityPool
 */
export const FundingStream_ToCommunityPool = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.FundingStream.ToCommunityPool",
  () => [
    { no: 2, name: "rate_bps", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "FundingStream_ToCommunityPool"},
);

/**
 * Describes the reward and exchange rates and voting power for a validator in some epoch.
 *
 * @generated from message penumbra.core.component.stake.v1.RateData
 */
export const RateData = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.RateData",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "validator_reward_rate", kind: "message", T: Amount },
    { no: 5, name: "validator_exchange_rate", kind: "message", T: Amount },
  ],
);

/**
 * Describes the base reward and exchange rates in some epoch.
 *
 * @generated from message penumbra.core.component.stake.v1.BaseRateData
 */
export const BaseRateData = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.BaseRateData",
  () => [
    { no: 1, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "base_reward_rate", kind: "message", T: Amount },
    { no: 3, name: "base_exchange_rate", kind: "message", T: Amount },
  ],
);

/**
 * Describes the current state of a validator on-chain
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorStatus
 */
export const ValidatorStatus = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorStatus",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "state", kind: "message", T: ValidatorState },
    { no: 3, name: "voting_power", kind: "message", T: Amount },
    { no: 4, name: "bonding_state", kind: "message", T: BondingState },
  ],
);

/**
 * Describes the unbonding state of a validator's stake pool.
 *
 * @generated from message penumbra.core.component.stake.v1.BondingState
 */
export const BondingState = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.BondingState",
  () => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(BondingState_BondingStateEnum) },
    { no: 2, name: "unbonds_at_epoch", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "unbonds_at_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from enum penumbra.core.component.stake.v1.BondingState.BondingStateEnum
 */
export const BondingState_BondingStateEnum = proto3.makeEnum(
  "penumbra.core.component.stake.v1.BondingState.BondingStateEnum",
  [
    {no: 0, name: "BONDING_STATE_ENUM_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "BONDING_STATE_ENUM_BONDED", localName: "BONDED"},
    {no: 2, name: "BONDING_STATE_ENUM_UNBONDING", localName: "UNBONDING"},
    {no: 3, name: "BONDING_STATE_ENUM_UNBONDED", localName: "UNBONDED"},
  ],
);

/**
 * Describes the state of a validator
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorState
 */
export const ValidatorState = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorState",
  () => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(ValidatorState_ValidatorStateEnum) },
  ],
);

/**
 * @generated from enum penumbra.core.component.stake.v1.ValidatorState.ValidatorStateEnum
 */
export const ValidatorState_ValidatorStateEnum = proto3.makeEnum(
  "penumbra.core.component.stake.v1.ValidatorState.ValidatorStateEnum",
  [
    {no: 0, name: "VALIDATOR_STATE_ENUM_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "VALIDATOR_STATE_ENUM_DEFINED", localName: "DEFINED"},
    {no: 2, name: "VALIDATOR_STATE_ENUM_INACTIVE", localName: "INACTIVE"},
    {no: 3, name: "VALIDATOR_STATE_ENUM_ACTIVE", localName: "ACTIVE"},
    {no: 4, name: "VALIDATOR_STATE_ENUM_JAILED", localName: "JAILED"},
    {no: 5, name: "VALIDATOR_STATE_ENUM_TOMBSTONED", localName: "TOMBSTONED"},
    {no: 6, name: "VALIDATOR_STATE_ENUM_DISABLED", localName: "DISABLED"},
  ],
);

/**
 * Combines all validator info into a single packet.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorInfo
 */
export const ValidatorInfo = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorInfo",
  () => [
    { no: 1, name: "validator", kind: "message", T: Validator },
    { no: 2, name: "status", kind: "message", T: ValidatorStatus },
    { no: 3, name: "rate_data", kind: "message", T: RateData },
  ],
);

/**
 * A transaction action (re)defining a validator.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorDefinition
 */
export const ValidatorDefinition = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorDefinition",
  () => [
    { no: 1, name: "validator", kind: "message", T: Validator },
    { no: 2, name: "auth_sig", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A transaction action adding stake to a validator's delegation pool.
 *
 * @generated from message penumbra.core.component.stake.v1.Delegate
 */
export const Delegate = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.Delegate",
  () => [
    { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
    { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "unbonded_amount", kind: "message", T: Amount },
    { no: 4, name: "delegation_amount", kind: "message", T: Amount },
  ],
);

/**
 * A transaction action withdrawing stake from a validator's delegation pool.
 *
 * @generated from message penumbra.core.component.stake.v1.Undelegate
 */
export const Undelegate = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.Undelegate",
  () => [
    { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
    { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "unbonded_amount", kind: "message", T: Amount },
    { no: 4, name: "delegation_amount", kind: "message", T: Amount },
    { no: 5, name: "from_epoch", kind: "message", T: Epoch },
  ],
);

/**
 * A transaction action finishing an undelegation, converting (slashable)
 * "unbonding tokens" to (unslashable) staking tokens.
 *
 * @generated from message penumbra.core.component.stake.v1.UndelegateClaim
 */
export const UndelegateClaim = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.UndelegateClaim",
  () => [
    { no: 1, name: "body", kind: "message", T: UndelegateClaimBody },
    { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.UndelegateClaimBody
 */
export const UndelegateClaimBody = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.UndelegateClaimBody",
  () => [
    { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
    { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "penalty", kind: "message", T: Penalty },
    { no: 4, name: "balance_commitment", kind: "message", T: BalanceCommitment },
    { no: 5, name: "unbonding_start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.UndelegateClaimPlan
 */
export const UndelegateClaimPlan = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.UndelegateClaimPlan",
  () => [
    { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
    { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "penalty", kind: "message", T: Penalty },
    { no: 5, name: "unbonding_amount", kind: "message", T: Amount },
    { no: 6, name: "balance_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 9, name: "unbonding_start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * A list of pending delegations and undelegations.
 *
 * @generated from message penumbra.core.component.stake.v1.DelegationChanges
 */
export const DelegationChanges = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.DelegationChanges",
  () => [
    { no: 1, name: "delegations", kind: "message", T: Delegate, repeated: true },
    { no: 2, name: "undelegations", kind: "message", T: Undelegate, repeated: true },
  ],
);

/**
 * Track's a validator's uptime.
 *
 * @generated from message penumbra.core.component.stake.v1.Uptime
 */
export const Uptime = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.Uptime",
  () => [
    { no: 1, name: "as_of_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "window_len", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "bitvec", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Tracks our view of Tendermint's view of the validator set, so we can keep it
 * from getting confused.
 *
 * @generated from message penumbra.core.component.stake.v1.CurrentConsensusKeys
 */
export const CurrentConsensusKeys = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.CurrentConsensusKeys",
  () => [
    { no: 1, name: "consensus_keys", kind: "message", T: ConsensusKey, repeated: true },
  ],
);

/**
 * Tracks slashing penalties applied to a validator in some epoch.
 *
 * @generated from message penumbra.core.component.stake.v1.Penalty
 */
export const Penalty = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.Penalty",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Requests information about a specific validator.
 *
 * @generated from message penumbra.core.component.stake.v1.GetValidatorInfoRequest
 */
export const GetValidatorInfoRequest = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.GetValidatorInfoRequest",
  () => [
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.GetValidatorInfoResponse
 */
export const GetValidatorInfoResponse = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.GetValidatorInfoResponse",
  () => [
    { no: 1, name: "validator_info", kind: "message", T: ValidatorInfo },
  ],
);

/**
 * Requests information on the chain's validators.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorInfoRequest
 */
export const ValidatorInfoRequest = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorInfoRequest",
  () => [
    { no: 2, name: "show_inactive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorInfoResponse
 */
export const ValidatorInfoResponse = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorInfoResponse",
  () => [
    { no: 1, name: "validator_info", kind: "message", T: ValidatorInfo },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorStatusRequest
 */
export const ValidatorStatusRequest = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorStatusRequest",
  () => [
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorStatusResponse
 */
export const ValidatorStatusResponse = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorStatusResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: ValidatorStatus },
  ],
);

/**
 * Requests the compounded penalty for a validator over a range of epochs.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorPenaltyRequest
 */
export const ValidatorPenaltyRequest = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorPenaltyRequest",
  () => [
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 3, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "end_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorPenaltyResponse
 */
export const ValidatorPenaltyResponse = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorPenaltyResponse",
  () => [
    { no: 1, name: "penalty", kind: "message", T: Penalty },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.CurrentValidatorRateRequest
 */
export const CurrentValidatorRateRequest = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.CurrentValidatorRateRequest",
  () => [
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.CurrentValidatorRateResponse
 */
export const CurrentValidatorRateResponse = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.CurrentValidatorRateResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: RateData },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorUptimeRequest
 */
export const ValidatorUptimeRequest = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorUptimeRequest",
  () => [
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorUptimeResponse
 */
export const ValidatorUptimeResponse = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.ValidatorUptimeResponse",
  () => [
    { no: 1, name: "uptime", kind: "message", T: Uptime },
  ],
);

/**
 * Staking configuration data.
 *
 * @generated from message penumbra.core.component.stake.v1.StakeParameters
 */
export const StakeParameters = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.StakeParameters",
  () => [
    { no: 1, name: "unbonding_epochs", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "active_validator_limit", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "base_reward_rate", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "slashing_penalty_misbehavior", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "slashing_penalty_downtime", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "signed_blocks_window_len", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "missed_blocks_maximum", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "min_validator_stake", kind: "message", T: Amount },
    { no: 9, name: "unbonding_delay", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Genesis data for the staking component.
 *
 * @generated from message penumbra.core.component.stake.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.GenesisContent",
  () => [
    { no: 1, name: "stake_params", kind: "message", T: StakeParameters },
    { no: 2, name: "validators", kind: "message", T: Validator, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventTombstoneValidator
 */
export const EventTombstoneValidator = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventTombstoneValidator",
  () => [
    { no: 1, name: "evidence_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "current_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 5, name: "address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "voting_power", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorStateChange
 */
export const EventValidatorStateChange = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventValidatorStateChange",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "state", kind: "message", T: ValidatorState },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorVotingPowerChange
 */
export const EventValidatorVotingPowerChange = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventValidatorVotingPowerChange",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "voting_power", kind: "message", T: Amount },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorBondingStateChange
 */
export const EventValidatorBondingStateChange = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventValidatorBondingStateChange",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "bonding_state", kind: "message", T: BondingState },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventRateDataChange
 */
export const EventRateDataChange = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventRateDataChange",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "rate_data", kind: "message", T: RateData },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorDefinitionUpload
 */
export const EventValidatorDefinitionUpload = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventValidatorDefinitionUpload",
  () => [
    { no: 1, name: "validator", kind: "message", T: Validator },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorMissedBlock
 */
export const EventValidatorMissedBlock = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventValidatorMissedBlock",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventDelegate
 */
export const EventDelegate = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventDelegate",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 3, name: "amount", kind: "message", T: Amount },
  ],
);

/**
 * @generated from message penumbra.core.component.stake.v1.EventUndelegate
 */
export const EventUndelegate = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventUndelegate",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 3, name: "amount", kind: "message", T: Amount },
  ],
);

/**
 * Indicates a slashing penalty was applied to a validator's reward rates.
 *
 * @generated from message penumbra.core.component.stake.v1.EventSlashingPenaltyApplied
 */
export const EventSlashingPenaltyApplied = proto3.makeMessageType(
  "penumbra.core.component.stake.v1.EventSlashingPenaltyApplied",
  () => [
    { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "new_penalty", kind: "message", T: Penalty },
  ],
);

